import { ITariffLine } from '~/src/entities/tariff-lines';
import { getFinalPriceFromMinPrices } from '~/src/features/bundles/helpers/getFinalPriceFromMinPrices';

interface ITariffInTariffLines {
    description: string,
    url: string,
}

interface IGetMinCostTariffInTariffLinesResult extends ITariffInTariffLines {
    price: string,
}

interface IGetMinCostTariffInTariffLines extends ITariffInTariffLines {
    price: number,
}

export const getMinCostTariffInTariffLines = (
    tariffLines: ITariffLine[],
    isVillage: boolean,
): IGetMinCostTariffInTariffLinesResult => {
    const sortedTariffLines = tariffLines
        .map<IGetMinCostTariffInTariffLines>(tariffLine => ({
            description: tariffLine?.seo_description || tariffLine?.description || '',
            price: +getFinalPriceFromMinPrices(tariffLine.minPrices, isVillage),
            url: tariffLine?.alias && `full-buy?tariffName=${tariffLine?.alias}&monoTariff=true` || '',
        }))
        .sort((tariffA: IGetMinCostTariffInTariffLines, tariffB: IGetMinCostTariffInTariffLines) =>
            tariffA.price - tariffB.price);

    const result = sortedTariffLines[0] || {};
    return {
        ...result,
        price: result.price?.toString(),
    };
};
